<div class="container-fluid">
  <div class="row grid-row">
    <div class="col-12">
      <div class="scripting-codemirror-container">
        @if (label) {
          <label>
            {{label.key | translate}}
          </label>
        }
        <div class="d-flex align-items-center">
        @if (!hideProxyGenerationToggle && !readFromModel) {
          <cpq-toggle [name]="'forceProxyGeneration'" [(ngModel)]='script.forceProxyGeneration' [label]="{key:'Admin.AddEditScript.ForceProxyGeneration'}"
            [disabled]='disabled'>
          </cpq-toggle>
        }
        @if (!hideProxyGenerationToggle && readFromModel) {
          <cpq-toggle [name]="'forceProxyGeneration'" [(ngModel)]="readFromModel.model['forceProxyGeneration']" [label]="{key:'Admin.AddEditScript.ForceProxyGeneration'}"
            [disabled]='disabled'>
          </cpq-toggle>
        }
        @if (showLaunchVSCodeButton && vsCodePluginLink) {
          <a class="btn btn-secondary fiori3-btn-secondary ms-auto mb-3 d-none d-lg-inline-block" [href]="vsCodePluginLink">
            {{'Admin.AddEditScript.LaunchVSCode' | translate}}
          </a>  
        }
      </div>
        <div class="scripting-holder">
          <div class="codemirror-box" [ngStyle]="{'width': propertiesVisible ? '60%': '100%'}">
            @if (!readFromModel) {
              <cpq-codemirror #editor [(ngModel)]="script.script" [config]="config" (ngModelChange)="onModelChange.emit($event)" [disabled]='disabled'></cpq-codemirror>
            }
            @if (readFromModel) {
              <cpq-codemirror #editor [(ngModel)]="readFromModel.model[readFromModel.propName]" [config]="config" (ngModelChange)="onModelChange.emit($event)" [disabled]='disabled'></cpq-codemirror>
            }
            @if (!hideFooter) {
              <div class="codemirror-box-footer">
                <div class="codemirror-footer-container">
                  <div>
                    <a [ngClass]="{'cpq-disabled': disabled}" id="checkSyntax" (click)="!disabled && checkSyntax()" style="white-space: nowrap;">
                      {{ 'Admin.AddEditScript.CheckSyntax' | translate }}
                    </a>
                    <span [ngClass]="{'errors' : containsErrors, 'no-errors' : !containsErrors}">{{errorStatus}}</span>
                  </div>
                  <div class="text-center">
                    @if (!hideWorkbenchLink) {
                      <a [ngClass]="{'cpq-disabled': !canAccessWorkBench}" (click)="navigateToScriptWorkbench()" style="white-space: nowrap;">
                        {{ 'IronPythonContext.Workbench' | translate }}
                      </a>
                    }
                  </div>
                  @if (!propertiesVisible) {
                    <div class="text-right">
                      <a (click)="showScriptingMethodsList()" style="white-space: nowrap;">
                        {{ 'Admin.ScriptingCodemirror.ScriptingMethodsList' | translate }}
                      </a>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          @if (propertiesVisible) {
            <div class="scripting-properties cpq-scroll">
              <span class="sap-icon" (click)="propertiesVisible=!propertiesVisible">&#xe066;</span>
              <cpq-scripting-property [properties]="firstLevelProperties"></cpq-scripting-property>
            </div>
          }
          <!-- <i *ngIf="!propertiesVisible" class="fa fa-chevron-circle-right" (click)="propertiesVisible=!propertiesVisible"></i> -->
        </div>
        @if (containsErrors) {
          <div class="row">
            <div class="col-12">
              <div class="alert alert-danger">
                <span class="sap-icon">&#xe053;</span>
                <div class="content" [innerHTML]="errorMessage" id="scriptSyntaxError"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
